var orderBy = require('./orderBy')

var sortBy = orderBy

module.exports = sortBy



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/sortBy.js
// module id = 1177
// module chunks = 75